module.exports = __webpack_public_path__ + "static/media/activate-card.d11cda07.svg";